<template>
  <div>
    <swiper class="swiper" :options="swiperOptions">
      <swiper-slide v-for="(i, index) in ffc_banner.result" :key="index">
        <div class="relative h-450px sm-h-600px">
          <div class="w-full">
            <img
              :src="`${$imageURL}/${i.image}`"
              alt="Banner"
              class="w-full h-450px sm-h-600px object-cover filter-b5 bg-ddd9d8"
            />
          </div>
          <div
            class="absolute sm-wfull w-full top-0 left-0 h-450px sm-h-600px lg:px-0 md:px-0 px-4 flex items-center"
          >
            <div
              class="w-60 md-w-70 sm-wfull mx-auto flex flex-col justify-center items-center"
            >
              <p
                class="sm-fsize14 font-semibold clr-fff lg:mb-5 md:mb-4 mb-3 dynamicStyle text-center cust-textColor"
              >
                {{ i.subHeading ? i.subHeading : "" }}
              </p>
              <!-- <h2
                class="fsize40 md-fsize30 sm-fsize18 font-semibold lg:mb-4 md:mb-4 mb-2 clr-fff text-center"
              >
                EMPOWERING WORKPLACES,<br />EPMOWERING FUTURES
              </h2> -->
              <h2
                class="fsize40 md-fsize30 sm-fsize18 font-semibold lg:mb-4 md:mb-4 mb-2 clr-fff text-center"
              >
                {{ i.heading ? i.heading : "" }}
              </h2>

              <p
                class="fsize20 md:text-lg sm-fsize14 clr-fff text-center lg:pb-10 md:pb-10 pb-4 px-6"
              >
                {{ i.description ? i.description : "" }}
              </p>

              <a
                href="#getACallBack"
                v-smooth-scroll="{ duration: 1000, offset: -10 }"
                class="js-anchor-link"
              >
                <button
                  class="rounded-full py-2 px-4 bg4F0A4B clr-fff sm-fsize14"
                  @click="onchange(i.cta)"
                >
                  <!-- @click="handleScroll(i.ctaRoute)" -->
                  {{ i.cta ? i.cta : "" }}
                </button>
              </a>
              <!-- <button
                class="rounded-full py-2 px-4 bg4F0A4B clr-fff sm-fsize14"
                v-else
                @click="onchange(i.cta)"
              >
                
                <a
                  href="#getACallBack"
                  v-smooth-scroll="{ duration: 1000, offset: -10 }"
                  class="js-anchor-link"
                >
                  {{ i.cta ? i.cta : "" }}
                </a>
              </button> -->
            </div>
          </div>
        </div>
      </swiper-slide>
      <!-- <swiper-slide>
        <div class="relative h-450px sm-h-600px">
          <div class="w-full">
            <img
              :src="`${$imageURL}/${i.image}`"
              alt="Banner"
              class="w-full h-450px sm-h-600px object-cover filter-b5 bg-ddd9d8"
            />
          </div>
          <div
            class="absolute sm-wfull w-full top-0 left-0 h-450px sm-h-600px lg:px-0 md:px-0 px-4 flex items-center"
          >
            <div
              class="w-60 md-w-70 sm-wfull mx-auto flex flex-col justify-center items-center"
            >
              <p
                class="sm-fsize14 font-semibold clr-fff lg:mb-5 md:mb-4 mb-3 dynamicStyle text-center cust-textColor"
              >
                FUTURE FIT CORPORATES
              </p>
              <h2
                class="fsize40 md-fsize30 sm-fsize18 font-semibold lg:mb-4 md:mb-4 mb-2 clr-fff text-center"
              >
                EMPOWERING WORKPLACES,<br />EPMOWERING FUTURES
              </h2>

              <p
                class="fsize20 md:text-lg sm-fsize14 clr-fff text-center lg:pb-10 md:pb-10 pb-4 px-6"
              >
                Ensure your employee's well-being and peace of mind by creating
                a workplace where everyone thrives and feels cared for.
              </p>
              <button
                class="rounded-full py-2 px-4 bg-cd4eaf clr-fff sm-fsize14"
                @click="handleScroll"
              >
                Get a Call Back
              </button>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="relative h-450px sm-h-600px">
          <div class="w-full">
            <img
              :src="`${$imageURL}/${imgUrl}`"
              alt="Banner"
              class="w-full h-450px sm-h-600px object-cover filter-b5 bg-ddd9d8"
            />
          </div>
          <div
            class="absolute sm-wfull w-full top-0 left-0 h-450px sm-h-600px lg:px-0 md:px-0 px-4 flex items-center"
          >
            <div
              class="w-60 md-w-70 sm-wfull mx-auto flex flex-col justify-center items-center"
            >
              <p
                class="sm-fsize14 font-semibold clr-fff lg:mb-5 md:mb-4 mb-3 dynamicStyle text-center cust-textColor"
              >
                Corporate Webinar
              </p>
              <h2
                class="fsize40 md-fsize30 sm-fsize18 font-semibold lg:mb-4 md:mb-4 mb-2 clr-fff text-center uppercase"
              >
                Inclusive Leadership,<br />Inclusive Workplace
              </h2>

              <p
                class="fsize20 md:text-lg sm-fsize14 clr-fff text-center lg:pb-10 md:pb-10 pb-4 px-6"
              >
                Equip your team with knowledge and tools to support caregivers and improve overall workspace well-being .
              </p>
              <button
                class="rounded-full py-2 px-4 bg-cd4eaf clr-fff sm-fsize14"
                @click="handleScroll"
              >
                Organization a webinar today 
              </button>
            </div>
          </div>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="relative h-450px sm-h-600px">
          <div class="w-full">
            <img
              :src="`${$imageURL}/${imgUrl}`"
              alt="Banner"
              class="w-full h-450px sm-h-600px object-cover filter-b5 bg-ddd9d8"
            />
          </div>
          <div
            class="absolute sm-wfull w-full top-0 left-0 h-450px sm-h-600px lg:px-0 md:px-0 px-4 flex items-center"
          >
            <div
              class="w-60 md-w-70 sm-wfull mx-auto flex flex-col justify-center items-center"
            >
              <p
                class="sm-fsize14 font-semibold clr-fff lg:mb-5 md:mb-4 mb-3 dynamicStyle text-center cust-textColor"
              >
                Experience Center 
              </p>
              <h2
                class="fsize40 md-fsize30 sm-fsize18 font-semibold lg:mb-4 md:mb-4 mb-2 clr-fff text-center uppercase"
              >
                Transformative Engagement, <br />Employee Well-being
              </h2>

              <p
                class="fsize20 md:text-lg sm-fsize14 clr-fff text-center lg:pb-10 md:pb-10 pb-4 px-6"
              >
                Engage in an immersive experience, gaining insights into the challenges faced by caregivers and exploring practical ways to support their well-being.
              </p>
              <button
                class="rounded-full py-2 px-4 bg-cd4eaf clr-fff sm-fsize14"
                @click="handleScroll"
              >
                Arrange the experience Center at your organization.
              </button>
            </div>
          </div>
        </div>
      </swiper-slide>  -->
      <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
      <div class="swiper-button-next adminswiper" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      allBanners: [],
      imgUrl: "",
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    handleScroll(URL) {
      // const el = document.getElementById("corporateForm");
      // el.scrollIntoView({ behavior: "smooth", block: "center" });
      if (URL.includes("http")) {
        return URL;
      } else {
        return "https://" + URL;
      }
    },
    onchange(val) {
      // if (val == "Arrange the Experience Centre at Your Organization") {
      this.$store.commit("ffc/setselectservice", val);

      // } else {
      //   this.$store.commit("ffc/setselectservice", false);
      // }
      // console.log("value", val);
    },
  },
  computed: {
    ...mapState("ffc", { ffc_banner: "ffc_banner" }),
    // imgUrl() {
    //   return this.ffc_banner.result[0].image;
    // },
  },
  async mounted() {
    let { data } = await this.$store.dispatch("ffc/get_banner");
    console.log(data.result, "DATA");
    this.allBanners = data.result;
    // this.imgUrl = this.ffc_banner.result[0].image;
  },
};
</script>
<style>
.h-450px {
  height: 450px !important;
}
.w-60 {
  width: 60%;
}
@media (max-width: 820px) and (min-width: 641px) {
  .md-w-70 {
    width: 70%;
  }
}
@media (max-width: 640px) {
  .sm-h-600px {
    height: 280px !important;
  }
  .sm-wfull {
    width: 100% !important;
  }
}
.hero-header {
  @media (max-width: 640px) {
    font-size: 24px !important;
    line-height: 32px !important;
    font-weight: 600 !important;
  }
}
.bg-ddd9d8 {
  background-color: #ddd9d8;
}
.clr-fff {
  color: #ffffff !important;
}
.bg-4f0a4b {
  background: #4f0a4b;
}
.adminswiper.swiper-button-next,
.swiper-button-prev {
  height: 27px !important;
}
</style>
